export default {
    lightIntensity: 1,
    minCamRadius: 10,
    maxCamRadius: 100,
    panSensibility: 0, // 0 is deactivated
    backgroundRed: 45 / 255,
    backgroundGreen: 55 / 255,
    backgroundBlue: 70 / 255,
    backgroundHex: "#2D3746",

    // Controller Funktionen, die per babylonState benutzt werden können
    // mit Standardwerten, wenn im State nichts gesetzt ist.
    functionDefaults: {
        setAnimationSpeed: [200],
        moveCamera:[-8.7, 1.6,10,12,.5,0],
        //moveCamera: [4.1, 0.25 * Math.PI, 15, 0, 0, 0],
    }
};